export default {
  funnel: {
    name: 'Funnel Progressions',
    interactive: false,
  },
  impression: {
    name: 'Impressions',
    interactive: false,
  },
  timing: {
    name: 'Timing',
    interactive: false,
  },
  default: {
    name: 'UI Interactions',
    interactive: true,
  },
  hover: {
    name: 'UI Interactions',
    interactive: true,
  },
  click: {
    name: 'UI Interactions',
    interactive: true,
  },
  submit: {
    name: 'UI Interactions',
    interactive: true,
  },
  segment: {
    name: 'UI A/B Test Segments',
    interactive: true,
  },
  error: {
    name: 'UI Errors',
    interactive: true,
  },
  multi: {
    name: 'Multi-object Events',
    interactive: true,
  },
  other: {
    name: 'Other Events',
    interactive: true,
  },
}
